// extracted by mini-css-extract-plugin
module.exports =  {"content":"K_I1NhJ","variant-white":"LievgZq","variantWhite":"LievgZq"};